import { render, staticRenderFns } from "./UrlPatternModal.vue?vue&type=template&id=24aebdc4&"
import script from "./UrlPatternModal.vue?vue&type=script&lang=js&"
export * from "./UrlPatternModal.vue?vue&type=script&lang=js&"
import style0 from "./UrlPatternModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports